 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/Cover'
 import TEXTFRONTMATTER from '@/components/Text/FrontMatter'
 import TEXTOTHERBOOKS from '@/components/Text/OtherBooks'
 import TEXTTITLEPAGE from '@/components/Text/TitlePage'
 import TEXTCOPYRIGHTPAGE from '@/components/Text/CopyrightPage'
 import TEXTDEDICATION from '@/components/Text/Dedication'
 import TEXTEPIGRAPH from '@/components/Text/Epigraph'
 import TEXTHALFTITLE from '@/components/Text/HalfTitle'
 import TEXTPROLOGUE from '@/components/Text/Prologue'
 import TEXTCHAPTER01 from '@/components/Text/Chapter01'
 import TEXTCHAPTER02 from '@/components/Text/Chapter02'
 import TEXTCHAPTER03 from '@/components/Text/Chapter03'
 import TEXTCHAPTER04 from '@/components/Text/Chapter04'
 import TEXTCHAPTER05 from '@/components/Text/Chapter05'
 import TEXTCHAPTER06 from '@/components/Text/Chapter06'
 import TEXTCHAPTER07 from '@/components/Text/Chapter07'
 import TEXTCHAPTER08 from '@/components/Text/Chapter08'
 import TEXTCHAPTER09 from '@/components/Text/Chapter09'
 import TEXTCHAPTER10 from '@/components/Text/Chapter10'
 import TEXTCHAPTER11 from '@/components/Text/Chapter11'
 import TEXTCHAPTER12 from '@/components/Text/Chapter12'
 import TEXTCHAPTER13 from '@/components/Text/Chapter13'
 import TEXTCHAPTER14 from '@/components/Text/Chapter14'
 import TEXTCHAPTER15 from '@/components/Text/Chapter15'
 import TEXTCHAPTER16 from '@/components/Text/Chapter16'
 import TEXTABOUTTHEAUTHOR from '@/components/Text/AboutTheAuthor'
 import TEXTSUMMITSERIES from '@/components/Text/SummitSeries'
 import TEXTMAPOFMURDER from '@/components/Text/MapOfMurder'
 import TEXTSEVENSUMMITS from '@/components/Text/SevenSummits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/Cover",
 			"name" : "Text/Cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/FrontMatter",
 			"name" : "Text/FrontMatter",
 			"component" : TEXTFRONTMATTER
 		},
 		{
 			"path" : "/Text/OtherBooks",
 			"name" : "Text/OtherBooks",
 			"component" : TEXTOTHERBOOKS
 		},
 		{
 			"path" : "/Text/TitlePage",
 			"name" : "Text/TitlePage",
 			"component" : TEXTTITLEPAGE
 		},
 		{
 			"path" : "/Text/CopyrightPage",
 			"name" : "Text/CopyrightPage",
 			"component" : TEXTCOPYRIGHTPAGE
 		},
 		{
 			"path" : "/Text/Dedication",
 			"name" : "Text/Dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/Epigraph",
 			"name" : "Text/Epigraph",
 			"component" : TEXTEPIGRAPH
 		},
 		{
 			"path" : "/Text/HalfTitle",
 			"name" : "Text/HalfTitle",
 			"component" : TEXTHALFTITLE
 		},
 		{
 			"path" : "/Text/Prologue",
 			"name" : "Text/Prologue",
 			"component" : TEXTPROLOGUE
 		},
 		{
 			"path" : "/Text/Chapter01",
 			"name" : "Text/Chapter01",
 			"component" : TEXTCHAPTER01
 		},
 		{
 			"path" : "/Text/Chapter02",
 			"name" : "Text/Chapter02",
 			"component" : TEXTCHAPTER02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js